<template>
  <div>
    <data-table
      :items="items"
      v-on:updateData="getGrvs"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:headings>
        <div class="col-md-1">GRV</div>
        <div class="col-md-4">Created</div>
        <div class="col-md-4">Amount</div>
        <div class="col-md-3 text-left text-md-right">Action</div>
      </template>

      <template v-slot:rows="slotProps">
        <div class="col-md-1 my-auto">
          <p class="m-0">{{ slotProps.item.goods_received_number }}</p>
        </div>

        <div class="col-md-4 my-auto">
          {{
            moment(new Date(slotProps.item.created_at)).format(
              "DD MMM YY, HH:mm"
            )
          }}
        </div>

     
        <div class="col-md-4 my-auto">
          <p class="m-0 text-primary">{{ slotProps.item.total_amount | currency }}</p>
        </div>

      

        <div class="col-md-3 my-auto text-left text-md-right pt-3 pt-md-0">
        
          <i
            class="lni lni-search-alt pointer text-primary mr-3"
            @click="
              selectedGrv = slotProps.item;
              invoiceGrv = true;
            "
          ></i>

        </div>
      </template>
    </data-table>

    <b-modal
      :hide-footer="true"
      title="Job Details"
      size="xl"
      v-model="jobShow"
      :no-close-on-route-change="true"
      :lazy="true"
    >
      <job :id="selectedJob"></job>
    </b-modal>

    <b-modal
      :hide-footer="true"
      title="GRV Details"
      size="xl"
      v-model="invoiceGrv"
      :no-close-on-route-change="true"
      :lazy="true"
    >
      <table class="table table-sm border" v-if="selectedGrv">
        <tr>
          <td width="20%" class="bg-primary text-white">CODE</td>
          <td width="36%" class="bg-primary text-white">DESCRIPTION</td>
          <td width="8%" class="bg-primary text-white">QUANITY</td>
          <td width="18%" class="bg-primary text-white text-right">AMOUNT</td>
          <td width="18%" class="bg-primary text-white text-right">TOTAL</td>
        </tr>

        <tr v-for="line in selectedGrv.goods_received_items" :key="line.id">
          <td>
            {{ line.part.code }}
          </td>
          <td>
            {{ line.part.description }}
          </td>
          <td>
            {{ line.quantity }}
          </td>
          <td class="text-right">
            <strong> {{ line.cost_price }}</strong>
          </td>
          <td class="text-right">
            <strong> {{ line.line_total }}</strong>
          </td>
        </tr>

        <tr>
          <td class="border-0"></td>
          <td class="border-0"></td>
          <td class="border-0"></td>
          <td class="border-0"></td>
          <td class="border-0"></td>
        </tr>



        <tr>
          <td colspan="3" class="bg-light"></td>
          <td class="text-right bg-light lead">
            <strong>TOTAL DUE</strong>
          </td>
          <td class="text-right bg-light lead">
            <strong>{{ selectedGrv.total_amount }}</strong>
          </td>
        </tr>
      </table>
    </b-modal>
  </div>
</template>

<script>
import accountRepo from "@/api/repos/accountRepo";
import dataTable from "@/components/common/DataTable";
import job from "@/views/modules/jobs/enquiryDetailed";

export default {
  props: ["accountId"],

  components: {
    job,
    dataTable,
  },

  data() {
    return {
      jobShow: false,
      selectedJob: null,
      invoiceGrv: false,
      selectedGrv: null,
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "created_at", label: "Latest", order: "desc" },
      sortOptions: [
        { column: "created_at", label: "Oldest", order: "asc" },
        { column: "created_at", label: "Latest", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getGrvs({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      search: "",
    });
  },
  methods: {
    async getGrvs(e) {
      this.isLoad = true;
      try {
        let { data } = await accountRepo.accountGrvs(
          this.accountId,
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.grvs.data;
        this.totalRows = data.grvs.total;
        this.page = data.grvs.current_page;
        this.fromRow = data.grvs.from;
        this.toRow = data.grvs.to;
        this.lastPage = data.grvs.last_page;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },
  
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
